import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FileUploadService } from '../services/file-upload.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginForm = this.fb.group({
    user: ['', Validators.required],
    password: ['', Validators.required]
  });

  constructor(
    private service: FileUploadService,
    private fb: FormBuilder,
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  async login() {
    try {
      const user = this.loginForm.get('user')!.value;
      const password = this.loginForm.get('password')!.value;
      await this.service.login(
        user,
        password
      );
      if (
        user === 'alfredo.nolasco@chihuahuaglobal.org' ||
        user === 'federico.talavera@fronteradevelopment.mx' ||
        user === 'stephanie.hinojos@chihuahuaglobal.org') {
        return this.router.navigate(['/admin']);
      }
      return this.router.navigate(['/intranet']);
    } catch (e) {
      console.log(e);
      return alert(e.message);
    }
  }

}
